import { Hero } from "../components/Hero";
import { StatsDashboard } from "../components/StatsDashboard";
import { AppsGrid } from "../components/AppsGrid";
import { MarqueeStrip } from "../components/MarqueeStrip";
import { Manifesto } from "../components/Manifesto";
import { ContactCTA } from "../components/ContactCTA";
import { RealizationsShowcase } from "../components/RealizationsShowcase";
import { AppsPortal } from "../components/AppsPortal";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <AppsPortal />
      <MarqueeStrip />
      <AppsGrid />
      <RealizationsShowcase />
      <StatsDashboard />
      <Manifesto />
      <ContactCTA />
    </main>
  );
}
